import { classNames } from "../utils/etc";
import styles from "./spinner.module.scss";

export function Spinner(props: { class?: string }) {
  return <div class={classNames(props.class, styles.spinner)} />;
}
